import * as React from "react";
import { FvcAnalysisSet, FvcAnalysisSetTest, FvcSession, FvcTest } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { TestQualityGradeIndicator } from "../../Shared/TestQualityGradeIndicator";
import { TestQualityGrade } from "../../Shared/TestQualityGrading";
import { AcceptabilityNextGenState, useAcceptabilityNextGen } from "../../Shared/UseAcceptabilityNextGen";
import { SpirometryAnalysisSetTypeEnum } from "../../../misc/api/ApiSpirometryAnalysisSetType";
import { ErrorBoundary } from "../../../errors/ErrorBoundary";

export interface NextGenTestAcceptabilityProps {
    viewOnly: boolean;
    loading: boolean;
    session: FvcSession;
    analysisSet: FvcAnalysisSet;
    acceptabilityState: AcceptabilityNextGenState;
    onAcceptabilityChange: (testId: string, checked: boolean) => void;
    comparisonAnalysisSet?: FvcAnalysisSet;
}

export interface NextGenTestOverreaderAcceptabilityProps {
    viewOnly: boolean;
    tests: FvcTest[];
    analysisSetTests: FvcAnalysisSetTest[]
    onAcceptabilityChange: (testId: string, checked: boolean) => void;
}

export interface NextGenTestTechnicianAcceptabilityProps {
    tests: FvcTest[];
    comparisonAnalysisSet?: FvcAnalysisSet;
}

export const NextGenTestAcceptability = ({ viewOnly, loading, session, analysisSet, acceptabilityState, onAcceptabilityChange, comparisonAnalysisSet = undefined }: NextGenTestAcceptabilityProps) => {
    const { fvcSettings } = useCurrentStudyConfigurationContext();

    return (
        <ErrorBoundary>
            <tr>
                <td>Acceptable</td>
                {session.tests.sort((a, b) => a.index - b.index).map((t) => {
                    return (
                        <td key={`OverreaderAcceptability${t.id}`}>
                            <input disabled={viewOnly} data-automationid="test-acceptability" data-test-number={t.index}
                                checked={analysisSet.tests.find(ast => ast.testId === t.id) && analysisSet.tests.find(ast => ast.testId === t.id).accepted !== undefined ? analysisSet.tests.find(ast => ast.testId === t.id).accepted : false}
                                type="checkbox"
                                onChange={(e) => onAcceptabilityChange(t.id, e.target.checked)}
                            />
                        </td>
                    );
                })}
                <td>
                    {fvcSettings.GradingEnabled ?
                        <>
                            <TestQualityGradeIndicator title="FEV1" loading={loading} grade={acceptabilityState.analysisSet.fev1Grade as TestQualityGrade} />
                            <TestQualityGradeIndicator title="FVC" loading={loading} grade={acceptabilityState.analysisSet.fvcGrade as TestQualityGrade} />
                        </> : null}
                </td>
                <td></td>
                <td></td>
            </tr>
            {comparisonAnalysisSet ? <tr>
                <td>Technician Acceptability</td>
                {session.tests.sort((a, b) => a.index - b.index).map((t) => {
                    return (
                        <td key={`TechnicianAcceptability${t.id}`}>
                            <input disabled={true} readOnly={true}
                                checked={comparisonAnalysisSet.tests.find(ast => ast.testId === t.id).accepted}
                                data-automationid={`test-acceptability-technician-${t.index}`}
                                type="checkbox"
                            />
                        </td>
                    );
                })}
                <td></td>
                <td></td>
                <td></td>
            </tr> : null}
        </ErrorBoundary>
    );
}

export const NextGenTestOverreaderAcceptability = (props: NextGenTestOverreaderAcceptabilityProps) => {
    return <>
        {props.tests.sort((a, b) => a.index - b.index).map((t) => {
            return (
                <td key={`OverreaderAcceptability${t.id}`}>
                    <input disabled={props.viewOnly} data-automationid="test-acceptability" data-test-number={t.index}
                        checked={props.analysisSetTests.find(ast => ast.testId === t.id) && props.analysisSetTests.find(ast => ast.testId === t.id).accepted !== undefined ? props.analysisSetTests.find(ast => ast.testId === t.id).accepted : false}
                        type="checkbox"
                        onChange={(e) => props.onAcceptabilityChange(t.id, e.target.checked)}
                    />
                </td>
            );
        })}
    </>;
}

export const NextGenTestTechnicianAcceptability = (props: NextGenTestTechnicianAcceptabilityProps) => {
    return <>
        {props.tests.sort((a, b) => a.index - b.index).map((t) => {
            return (
                <td key={`TechnicianAcceptability${t.id}`}>
                    <input disabled={true} readOnly={true}
                        checked={props.comparisonAnalysisSet.tests.find(ast => ast.testId === t.id).accepted}
                        data-automationid={`test-acceptability-technician-${t.index}`}
                        type="checkbox"
                    />
                </td>
            );
        })}
    </>;
}